var map = {
	"./afb-color.svg": 643,
	"./alb-color.svg": 644,
	"./all.svg": 645,
	"./amb-color.svg": 646,
	"./arg.svg": 647,
	"./aus.svg": 648,
	"./bank-icon.svg": 649,
	"./bankdemo-color.svg": 650,
	"./bel.svg": 651,
	"./bimb-color.svg": 652,
	"./bkr-color.svg": 653,
	"./bpay-color.svg": 654,
	"./bra.svg": 655,
	"./bsn-color.svg": 656,
	"./can.svg": 657,
	"./checked-blue.webp": 1634,
	"./checked-green.png": 658,
	"./checked-white.png": 659,
	"./cimb-color.svg": 660,
	"./cimb-icon.svg": 661,
	"./citi-color.svg": 662,
	"./cmr.svg": 663,
	"./crc.svg": 664,
	"./cro.svg": 665,
	"./den.svg": 666,
	"./ecu.svg": 667,
	"./eng.svg": 668,
	"./esp.svg": 669,
	"./fav-blue.svg": 670,
	"./fav-blue.webp": 1635,
	"./fav-gray.png": 671,
	"./fav-gray.svg": 672,
	"./fav-gray.webp": 1636,
	"./fav-icon-active.png": 673,
	"./fav-icon.png": 674,
	"./fav-red.png": 675,
	"./fra.svg": 676,
	"./game-icon.svg": 677,
	"./games-active-m.svg": 678,
	"./games-m.webp": 1637,
	"./ger.svg": 679,
	"./gha.svg": 680,
	"./gxbank-color.svg": 681,
	"./hlb-color.svg": 682,
	"./hlb-icon.svg": 683,
	"./hsbc-color.svg": 684,
	"./irn.svg": 685,
	"./jpn.svg": 686,
	"./kor.svg": 687,
	"./ksa.svg": 688,
	"./kwh-color.svg": 689,
	"./latest-icon-active.png": 690,
	"./latest-icon.png": 691,
	"./lc-active-m.svg": 692,
	"./lc-icon.svg": 693,
	"./lc-m.webp": 1638,
	"./lottery-active-m.svg": 694,
	"./lottery-icon.svg": 695,
	"./lottery-m.svg": 696,
	"./love.svg": 697,
	"./mar.svg": 698,
	"./mbb-color.svg": 699,
	"./mex.svg": 700,
	"./ned.svg": 701,
	"./ocbc-color.svg": 702,
	"./ocbc-icon.svg": 703,
	"./p2p-active-m.svg": 704,
	"./p2p-icon.svg": 705,
	"./p2p-m.svg": 706,
	"./pbb-color.svg": 707,
	"./pol.svg": 708,
	"./por.svg": 709,
	"./price-high.svg": 710,
	"./price-low.svg": 711,
	"./qat.svg": 712,
	"./rhb-color.svg": 713,
	"./rhb-icon.svg": 714,
	"./scb-color.svg": 715,
	"./sen.svg": 716,
	"./slot-active-m.svg": 717,
	"./slot-icon.svg": 718,
	"./slot-m.webp": 1639,
	"./sport-active-m.svg": 719,
	"./sport-m.webp": 1640,
	"./sports-icon.svg": 720,
	"./srb.svg": 721,
	"./star.svg": 722,
	"./sui.svg": 723,
	"./tng-color.svg": 724,
	"./trx-icon.svg": 725,
	"./trx.svg": 726,
	"./tun.svg": 727,
	"./uob-color.svg": 728,
	"./uru.svg": 729,
	"./usa.svg": 730,
	"./usdc.svg": 731,
	"./usdt.svg": 732,
	"./ustd-icon.svg": 733,
	"./wal.svg": 734,
	"./x33-logo-b.svg": 735,
	"./x33-square-icon.svg": 736
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 465;